import { render } from "./ShomeiListTable.vue?vue&type=template&id=5d868483&ts=true"
import script from "./ShomeiListTable.vue?vue&type=script&lang=ts"
export * from "./ShomeiListTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QInnerLoading,QCard,QItem});
